import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Reporting Type List with Query (for remote operations)
export const getReportingTypeListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_REPORTING_TYPES}?${stringifyParams(
			params
		)}`
	);
};

// Get Reporting Type List
export const getReportingTypeList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_REPORTING_TYPES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Reporting Type
export const getReportingType = reporting_type_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_REPORTING_TYPE}${reporting_type_id}`
	);
};

// Add New Reporting Type
export const addNewReportingTypeApi = reporting_type => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_REPORTING_TYPE}`,
		reporting_type
	);
};

// Update Reporting Type
export const updateReportingTypeApi = reporting_type => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_REPORTING_TYPE}${reporting_type._id}`,
		reporting_type
	);
};

// Delete Reporting Type
export const deleteReportingTypeApi = reporting_type_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_REPORTING_TYPE}${reporting_type_id}`
	);
};

// Check if Reporting Type Exists
export const checkReportingTypeExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_REPORTING_TYPE_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
